import BaseContextMenu from '@components/ContextMenu/BaseContextMenu';
import AdditionalSliceContent, { AdditionalSliceContentProps } from './AdditionalSliceContent';

const AdditionalSliceContextMenu = ({
  value,
  min,
  max,
  onChangeValue,
  onReset,
  onClose,
}: AdditionalSliceContentProps) => {
  return (
    <BaseContextMenu onClose={onClose}>
      <AdditionalSliceContent
        value={value}
        min={min}
        max={max}
        onChangeValue={onChangeValue}
        onReset={onReset}
        onClose={onClose}
      />
    </BaseContextMenu>
  );
};

export default AdditionalSliceContextMenu;
